export const ShapeDividerBuilderID = 'wixSystemElements.BackgroundShapeDivider'
